import { render, staticRenderFns } from "./merchantAccountList.vue?vue&type=template&id=b774c140&scoped=true"
import script from "./merchantAccountList.vue?vue&type=script&lang=js"
export * from "./merchantAccountList.vue?vue&type=script&lang=js"
import style0 from "./merchantAccountList.vue?vue&type=style&index=0&id=b774c140&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b774c140",
  null
  
)

export default component.exports